import React, { useEffect, useState } from "react";
import DataTableBase from "../../../Components/Common/DataTableBase/DataTableBase";
import { t } from "i18next";
import { useLinksStore } from "../../../stores/Assets/links";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledTooltip,
  Input,
  Label,
  FormGroup,
} from "reactstrap";
import AddLink from "./Components/AddLink";
import AddSiteLink from "./Components/AddSiteLink";
import SiteLinksTable from "./Components/SiteLinksTable";

import { Link, useLocation } from "react-router-dom";
import { useConfirmDialogStore } from "../../../stores/Modal/ConfirmDialogStore";
import { Pagination } from "../../../Components/Common/DataTableBase/Pagination";
import { useSiteStore } from "../../../stores/Assets/site";
import { canEdit } from "../../../helpers/permissions";
import { useSpaceStore } from "../../../stores/Assets/space";
import { Card, CardBody, CardHeader } from "reactstrap";
import ReactSelect from "react-select";
import { reactSelectStyling } from "../../../Components/Common/Forms/FormikInputHelper";
import Skeleton from "../../../Components/Common/Skeleton";

const Links = () => {
  const [totalRows, setTotalRows] = useState(0);
  const [formattedLinks, setFormattedLinks] = useState([]);
  const [filteredLinks, setFilteredLinks] = useState([]);
  const { getSites, sites } = useSiteStore((state) => state);
  const { getSpaces, spaces, ...restSpace } = useSpaceStore((state) => state);
  document.title = "Clickorder Admin";
  const location = useLocation();
  const menuId = new URLSearchParams(location.search).get("menuId");
  const {
    getLinks,
    isLoading,
    links,
    removeLink,
    pagination,
  } = useLinksStore((state) => state);

  const [showSiteError, setShowSiteError] = useState(false);
  const [showAddSiteLink, setShowAddSiteLink] = useState(false);

  useEffect(() => {
    getLinks(null, { page: 1, perPage: rowsPerPage });
    getSites();
  }, [getLinks, getSites]);

  // Filter states
  const [selectedSite, setSelectedSite] = useState("");
  const [selectedSpace, setSelectedSpace] = useState("");
  const [selectedSpaceOption, setSelectedSpaceOption] = useState(null);
  const [emailSearch, setEmailSearch] = useState("");
  const [uniqueSpaces, setUniqueSpaces] = useState([]);

  useEffect(() => {
    if (selectedSite) {
      setSelectedSpaceOption(null); // Reset space selection when site changes
      setSelectedSpace("");
      getSpaces(selectedSite, { page: 1, perPage: 999 });
    }
  }, [selectedSite]);

  // Convert spaces to React Select options
  const spaceFilterOptions = [
    { value: "", label: "All" },
    ...spaces.map((space) => ({
      value: space.space_id,
      label: `${space.space_id} - ${space.name}`,
    })),
  ];
  useEffect(() => {
    if (links) {
      // Transforming the data format
      const formattedData = links.flatMap((space) =>
        space?.users?.map((user) => ({
          space_id: space.space_id,
          site_id: space?.site?.site_id,
          site_name: space?.site?.name,
          space_name: space.space_name,
          user_email: user?.user_email,
        }))
      );

      setFormattedLinks(formattedData);
      setFilteredLinks(formattedData);
    }
  }, [links]);

  // Apply filters whenever filter criteria change
  // useEffect(() => {
  //   let filtered = formattedLinks;

  //   if (selectedSite) {
  //     filtered = filtered.filter((link) => link.site_id === selectedSite);
  //   }

  //   if (selectedSpace) {
  //     filtered = filtered.filter((link) => link.space_name === selectedSpace);
  //   }

  //   if (emailSearch) {
  //     filtered = filtered.filter((link) =>
  //       link.user_email.toLowerCase().includes(emailSearch.toLowerCase())
  //     );
  //   }

  //   setFilteredLinks(filtered);
  //   setTotalRows(filtered.length);
  // }, [selectedSite, selectedSpace, emailSearch, formattedLinks]);

  // Columns for Space Links table
  const columns = [
    {
      name: t("Site ID"),
      selector: (row) => row?.site_id,
      sortable: true,
      wrap: true,
    },
    {
      name: t("Site Name"),
      selector: (row) => row?.site_name,
      sortable: true,
      wrap: true,
    },
    {
      name: t("Space ID"),
      selector: (row) => row?.space_id,
      sortable: true,
      wrap: true,
    },
    {
      name: t("Space Name"),
      selector: (row) => row?.space_name,
      sortable: true,
      wrap: true,
    },
    {
      name: t("User Email"),
      selector: (row) => row?.user_email,
      sortable: true,
      wrap: true,
    },
  ];

  const { showConfirm } = useConfirmDialogStore((state) => state);

  const [showAddLink, setShowAddLink] = useState(false);
  const toggleAddLinkModal = () => {
    if (sites.length === 0) {
      setShowSiteError(true);
      return;
    }
    setShowAddLink(!showAddLink);
  };

  const toggleAddSiteLinkModal = () => {
    if (sites.length === 0) {
      setShowSiteError(true);
      return;
    }
    setShowAddSiteLink(!showAddSiteLink);
  };
  const [currentLinks, setCurrentLinks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const rowsPerPage = 10; // Display 5 rows per page
  // useEffect(() => {
  //   if (filteredLinks.length > 0) {
  //     const curr = filteredLinks.slice(
  //       (currentPage - 1) * rowsPerPage,
  //       currentPage * rowsPerPage
  //     );
  //     setCurrentLinks(curr);
  //   }
  // }, [currentPage, filteredLinks]);

  const onChangePage = (page) => {
    getLinks(null, { page, perPage: rowsPerPage });
    setCurrentPage(page);
  };
  const deleteLink = async (body) => {
    try {
      await removeLink(body);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    setTotalRows(pagination?.totalItems || 0);
  }, [pagination]);
  const [canEditLink, setCanEditLink] = useState(false);

  useEffect(() => {
    const checkPermission = async () => {
      const res = await canEdit("link");
      setCanEditLink(res);
    };

    checkPermission();
  }, []);

  // Auto-apply filters when they change
  useEffect(() => {
    const filters = {};

    if (selectedSite) {
      filters.site_id = parseInt(selectedSite);
    }

    if (selectedSpace) {
      filters.space_id = parseInt(selectedSpace);
    }

    if (emailSearch && emailSearch.trim() !== "") {
      filters.email = emailSearch.trim();
    }

    // Only fetch if we have any filters, otherwise fetch all
    const hasFilters = Object.keys(filters).length > 0;

    getLinks(
      hasFilters ? filters : null,
      { page: 1, perPage: rowsPerPage }
    );
  }, [selectedSite, selectedSpace, emailSearch]);

  return (
    <>
      {showSiteError && (
        <Modal isOpen={showSiteError} toggle={() => setShowSiteError(false)}>
          <ModalHeader>No Registered Site</ModalHeader>
          <ModalBody>
            <div className="text-center">
              <p className="text-danger">{t("You should first add a site.")}</p>
              <Link to="/sites" className="btn btn-primary">
                {t("Add a Site")}
              </Link>
            </div>
          </ModalBody>
        </Modal>
      )}
      <>
        <DataTableBase
          tableTitle={"LINKS"}
          customHeader={
            sites.length === 0 ? (
              // Skeleton loading state
              <div className="d-flex flex-column flex-md-row align-items-stretch justify-content-between gap-2 w-100 mb-2">
                <div className="w-100" style={{ flex: '0 0 10%' }}>
                  <Skeleton variant="button" />
                </div>
                <div className="d-flex flex-column flex-md-row align-items-stretch gap-2 w-100 px-2" style={{ flex: '0 0 60%' }}>
                  <div className="d-flex align-items-center gap-2 w-100">
                    <h6 className="text-nowrap mb-0">Site: </h6>
                    <div className="flex-grow-1">
                      <Skeleton variant="input" />
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-2 w-100">
                    <h6 className="text-nowrap mb-0">Email: </h6>
                    <div className="flex-grow-1">
                      <Skeleton variant="input" />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="d-flex flex-column flex-md-row align-items-stretch justify-content-between gap-2 w-100 mb-2">
                {canEditLink ? (
                  <Button
                    color="success"
                    onClick={toggleAddLinkModal}
                    className="d-flex align-items-center justify-content-center w-100"
                    style={{ flex: '0 0 10%', padding: '0.4rem 2rem', whiteSpace: 'nowrap', fontSize: "13px" }}
                  >
                    + {t("Add Link")}
                  </Button>
                ) : null}
                <div className="d-flex flex-column flex-md-row align-items-stretch gap-2 w-100 px-2" style={{ flex: '0 0 60%' }}>
                  {sites.length > 0 && (
                    <div className="d-flex align-items-center gap-2 w-100">
                      <h6 className="text-nowrap mb-0">Site: </h6>
                      <select
                        className="form-control flex-grow-1"
                        value={selectedSite}
                        onChange={(e) => setSelectedSite(e.target.value)}
                      >
                        <option key={"all"} value={""}>
                          {"All"}
                        </option>
                        {sites.map((site, indx) => (
                          <option key={indx} value={site.site_id}>
                            {site.site_id} - {site.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {selectedSite && (
                    <div className="d-flex align-items-center gap-2 w-100">
                      <h6 className="text-nowrap mb-0">Space: </h6>
                      <div className="flex-grow-1">
                        <ReactSelect
                          {...reactSelectStyling}
                          options={spaceFilterOptions}
                          value={selectedSpaceOption}
                          onChange={(option) => {
                            setSelectedSpaceOption(option);
                            setSelectedSpace(option?.value || "");
                          }}
                          placeholder={t("Select Space...")}
                          isLoading={restSpace.isLoading}
                          isDisabled={restSpace.isLoading}
                          isClearable
                        />
                      </div>
                    </div>
                  )}

                  <div className="d-flex align-items-center gap-2 mr-3 w-100">
                    <h6 className="text-nowrap mb-0">Email: </h6>
                    <Input
                      className="flex-grow-1"
                      id="email-search"
                      type="text"
                      placeholder="Search by email..."
                      value={emailSearch}
                      onChange={(e) => setEmailSearch(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )
          }
          data={formattedLinks} // Display current paginated data
          columns={columns}
          loading={isLoading}
          paginationTotalRows={totalRows}
          onChangePage={onChangePage}
          onHeaderAddBtnClick={null}
          showSearch={false}
          showActionColumn={canEditLink}
          showSubHeader={false}
          showActionButtons={false}
          customActionBtns={(row) => (
            <>
              <button
                className="btn btn-sm btn-danger"
                onClick={() => {
                  showConfirm(
                    () => {
                      deleteLink({
                        email: row?.user_email,
                        space_id: row?.space_id,
                      });
                    },
                    () => {
                      console.log("Cancelled");
                    },
                    "Confirmation", // Title of the confirmation dialog
                    `Are you sure you want to delete the link?` // Question displayed in the dialog
                  );
                }}
                title="Delete"
              >
                <i className="ri-delete-bin-line"></i>
              </button>
            </>
          )}
        />

        {showAddLink && !showSiteError && (
          <AddLink
            sites={sites}
            toggleAddLinkModal={toggleAddLinkModal}
            showAddLinkModal={showAddLink}
          />
        )}

        {/* Site Links Table - Separate component with its own filters and loading state */}
        <SiteLinksTable onAddClick={toggleAddSiteLinkModal} />

        {showAddSiteLink && !showSiteError && (
          <AddSiteLink
            sites={sites}
            toggleAddSiteLinkModal={toggleAddSiteLinkModal}
            showAddSiteLinkModal={showAddSiteLink}
          />
        )}
      </>
    </>
  );
};

export default Links;
